// extracted by mini-css-extract-plugin
export var listItem = "menu-category-module--list-item--j-W-s";